<template>
	<div class="app-container">
		<el-form v-model="form" :inline="true" ref="filtrateForm" size="mini">
			<el-form-item label="订单号:" style="float: left">
				<el-input
					size="mini"
					v-model="form.spell_order_sn"
					style="width: 160px"
					placeholder="输入渠道订单号搜索"
				></el-input>
			</el-form-item>
			<el-form-item label="收货人手机号:" style="float: left">
				<el-input
					size="mini"
					v-model="form.receiver_mobile"
					style="width: 160px"
					placeholder="输入收货人手机号搜索"
				></el-input>
			</el-form-item>

			<el-form-item label="订单时间:" style="float: left">
				<el-row>
					<el-col :span="18">
						<el-date-picker
							v-model="selectedTime"
							type="daterange"
							align="right"
							unlink-panels
							format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:default-time="['00:00:00', '23:59:59']"
							:picker-options="timeOptions"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="发货时间:" style="float: left">
				<el-row>
					<el-col :span="18">
						<el-date-picker
							v-model="deliveryTime"
							type="daterange"
							align="right"
							unlink-panels
							format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:default-time="['00:00:00', '23:59:59']"
							:picker-options="timeOptions"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="签收时间:" style="float: left">
				<el-row>
					<el-col :span="18">
						<el-date-picker
							v-model="signTime"
							type="daterange"
							align="right"
							unlink-panels
							format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:default-time="['00:00:00', '23:59:59']"
							:picker-options="timeOptions"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="商品名称:" style="float: left">
				<el-input
					size="mini"
					placeholder="请输入商品名称搜索"
					style="width: 180px"
					v-model="form.goods_name"
				></el-input>
			</el-form-item>
			<el-form-item label="订单状态:" style="float: left">
				<el-select style="width: 180px" v-model="form.order_status">
					<el-option label="全部" value></el-option>
					<el-option
						v-for="(item, index) in order_status_list"
						:key="index"
						:label="item.name"
						:value="item.order_status"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="float: left">
				<el-button type="primary" @click="pageChange(1)">查询</el-button>
				<el-button @click="resetForm('filtrateForm')">重置</el-button>
				<el-button type="warning" @click="exportOrderData">导出</el-button>
			</el-form-item>
		</el-form>

		<el-table
			:data="tableData"
			max-height="600"
			size="mini"
			style="width: 100%"
			:cell-style="tc"
			:header-cell-style="tccolor"
			ref="table"
			@sort-change="sortChange"
			v-loading="loading"
		>
			<el-table-column
				label="渠道订单ID"
				prop="spell_order_sn"
				width="140"
			></el-table-column>
			<el-table-column
				label="收货人手机号"
				prop="receiver_mobile"
				width="140"
			></el-table-column>
			<el-table-column
				label="商品编号"
				prop="goods_no"
				width="140"
			></el-table-column>
			<el-table-column
				label="商品名称"
				prop="goods_name"
				width="140"
			></el-table-column>
			<el-table-column
				label="商品规格"
				prop="goods_mod_name"
				width="140"
			></el-table-column>

			<el-table-column label="商品图">
				<template slot-scope="scope">
					<img style="width: 36px; height: 36px" :src="scope.row.goods_img" />
				</template>
			</el-table-column>
			<el-table-column label="成本价" prop="cost_price"></el-table-column>
			<el-table-column label="供货价" prop="supply_price"></el-table-column>
			<el-table-column label="购买数量" prop="goods_num"></el-table-column>
			<el-table-column
				label="订单状态"
				prop="order_status_name"
			></el-table-column>
			<el-table-column
				label="创建时间"
				prop="create_order_time"
				width="140"
			></el-table-column>
			<el-table-column
				label="发货时间"
				prop="delivery_time"
				width="140"
			></el-table-column>
			<el-table-column
				label="签收时间"
				width="140"
				prop="sign_time"
			></el-table-column>
			<el-table-column label="操作" fixed="right" width="90">
				<template slot-scope="scope">
					<el-button
						type="warning"
						size="mini"
						@click="gotoOrderDetail(scope.row.id)"
						>详情</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<div class="info">订单数：{{ total }}</div>

		<div class="pagination">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="pageChange"
				:current-page="form.page"
				:page-sizes="[20, 50, 100]"
				:page-size="form.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>

		<gydialog title="订单日志" :visible.sync="showOrderDialog" width="640px">
			<div style="padding: 20px 12px">
				<el-table
					border
					:data="orderTableData"
					style="width: 100%"
					max-height="600"
					:cell-style="tc"
					:header-cell-style="tccolor"
					v-loading="loading"
				>
					<el-table-column label="更新时间" prop="created_at"></el-table-column>
					<el-table-column label="订单状态">
						<template slot-scope="scope">
							<p v-if="scope.row.order_status == 0">待支付</p>
							<p v-if="scope.row.order_status == 1">待发货</p>
							<p v-if="scope.row.order_status == 2">已发货</p>

							<p v-if="scope.row.order_status == 7">已收货</p>
							<p v-if="scope.row.order_status == 6">已签收</p>

							<p v-if="scope.row.order_status == 3">已取消</p>
							<p v-if="scope.row.order_status == 4">已完成</p>
							<p v-if="scope.row.order_status == 5">已关闭</p>
						</template>
					</el-table-column>

					<el-table-column label="日志备注" prop="log"></el-table-column>
				</el-table>
			</div>
		</gydialog>
	</div>
</template>
<script>
import { GySpellOrderList, exportSpellOrderList } from '@/api/order'
import { parseTime } from '@/utils/index'
import { BASE_API } from '@/config'
import store from '@/store/index'
export default {
	data() {
		return {
			action: `${BASE_API}/admin/order/import`,
			headers: {
				token: store.getters.token,
			},
			fileList: [],
			loading: false,
			order_out_type: '',
			form: {
				page: 1,
				page_size: 20,
				spell_order_sn: '',
				create_order_time_gt: '',
				create_order_time_lt: '',
				delivery_time_gt: '',
				delivery_time_lt: '',
				sign_time_gt: '',
				sign_time_lt: '',
				goods_name: '',
				orderBys: '',
				order_status: '',
				filename: '',
				receiver_mobile: '',
			},
			selectedTime: '',
			deliveryTime: '',
			signTime: '',
			timeOptions: {
				shortcuts: [
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近15天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(new Date().setMonth(new Date().getMonth() - 1))
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
			//来源数据
			sourceList: [],
			//供应商数据
			supplierList: [],
			tableData: [],
			total: 0,
			quantity_num: 0,
			order_status_list: [
				{ order_status: 1, name: '等待发货' },
				{ order_status: 2, name: '等待签收' },
				{ order_status: 3, name: '已经签收' },
				{ order_status: 4, name: '等待支付' },
				{ order_status: 5, name: '用户取消' },
				{ order_status: 6, name: '卖家取消' },
				{ order_status: 7, name: '系统取消' },
				{ order_status: 8, name: '超时取消' },
			],
			//日志
			showOrderDialog: false,
			currentId: '',
			orderTableData: [],
			orderTotal: 0,
			remarkform: {
				page: 1,
				size: 20,
			},
		}
	},

	mounted() {
		this.getList()
	},
	methods: {
		querySearch(queryString, cb) {
			var restaurants = this.sourceList
			var results = queryString
				? restaurants.filter(this.createFilter(queryString))
				: restaurants
			// 调用 callback 返回建议列表的数据
			console.log(results)
			cb(results)
		},
		createFilter(queryString) {
			return (sourceList) => {
				return (
					sourceList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		querySearch1(queryString, cb) {
			var restaurants = this.supplierList
			console.log(restaurants)
			var results = queryString
				? restaurants.filter(this.createFilter1(queryString))
				: restaurants
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		createFilter1(queryString) {
			console.log(queryString)
			return (supplierList) => {
				return (
					supplierList.supplier_name
						.toLowerCase()
						.indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect1(item) {
			console.log(item)
			this.form.supplier_id = item.id
		},
		pageChange(page) {
			this.form.page = page
			this.getList()
		},
		selectOrderType(id) {
			if (id == 1) {
				this.form.order_no = ''
			} else {
				this.form.out_order_no = ''
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.selectedTime = ''
			this.deliveryTime = ''
			this.signTime = ''
			this.order_out_type = ''
			this.form = {
				spell_order_sn: '',
				created_at_gt: '',
				created_at_lt: '',
				express_send_time_gt: '',
				express_send_time_lt: '',
				sign_time_start: '',
				sign_time_end: '',
				goods_name: '',
				page: this.form.page,
				page_size: this.form.page_size,
				orderBys: '',
				buyer_phone: '',
			}
		},
		//查看详情
		gotoOrderDetail(id) {
			this.$router.push({
				path: './ownDetail',
				query: {
					orderId: id,
				},
			})
		},

		handleSizeChange(val) {
			this.form.size = val
			this.pageChange(1)
		},
		sortChange(e) {
			if (e.order) {
				if (e.order == 'ascending') {
					this.form.orderBys = e.column.sortable
				} else {
					this.form.orderBys = '-' + e.column.sortChange
				}
			}
			this.pageChange(1)
		},
		remarkpageChange(page) {
			this.remarkform.page = page
			this.orderRemarkListData()
		},
		async getList() {
			const form = this.form
			if (this.selectedTime !== '') {
				form.create_order_time_gt = parseTime(
					this.selectedTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				form.create_order_time_lt = parseTime(
					this.selectedTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.deliveryTime !== '') {
				form.delivery_time_gt = parseTime(
					this.deliveryTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				form.delivery_time_lt = parseTime(
					this.deliveryTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.signTime !== '') {
				form.sign_time_gt = parseTime(this.signTime[0], 'yyyy-MM-dd hh:mm:ss')
				form.sign_time_lt = parseTime(this.signTime[1], 'yyyy-MM-dd hh:mm:ss')
			}
			let res = await GySpellOrderList(this.form)
			this.tableData = res.data
			this.total = res.total
			this.quantity_num = res.quantity_num
		},

		async exportOrderData() {
			if (this.selectedTime !== '') {
				this.form.create_order_time_gt = parseTime(
					this.selectedTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				this.form.create_order_time_lt = parseTime(
					this.selectedTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.deliveryTime !== '') {
				this.form.delivery_time_gt = parseTime(
					this.deliveryTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				this.form.delivery_time_lt = parseTime(
					this.deliveryTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.signTime !== '') {
				this.form.sign_time_gt = parseTime(
					this.signTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				this.form.sign_time_lt = parseTime(
					this.signTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			let res = await exportSpellOrderList(this.form)
			if (res.code === 2) {
				this.loading = true
				console.log(res)
				this.form.page = res.page
				this.form.filename = res.filename
				this.form.last_id = res.last_id
				this.exportOrderData()
			} else if (res.code === 1) {
				this.loading = false
				window.open(`${BASE_API}/admin/download/zip/${res.download_token}`)
			} else {
				this.loading = false
				this.$message.error(res.message)
			}
		},

		tc() {
			return 'text-align:center;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		},
	},
}
</script>
<style lang="scss" scoped>
.el-form {
	display: flex;
	flex-wrap: wrap;
}
.app-container {
	padding: 20px;
	background-color: #fff;
}
//已完成
.account_status_wancheng {
	color: #67c23a;
}
//已关闭
.account_status_guanbi {
	color: #f4222d;
}
//待支付
.account_status_zhifu {
	color: rgb(191, 191, 191);
}
//待发货
.account_status_fahuo {
	color: rgb(253, 190, 44);
}
//待收获
.account_status_shouhuo {
	color: rgb(26, 121, 206);
}
.pagination {
	float: right;
	margin-top: 20px;
}
.info {
	text-align: left;
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0;
}
</style>
